const { Component, Fragment } = wp.element;
const { sprintf } = wp.i18n;

/* global PaidMediaSearchVars: false */

class DatePicker extends Component {

  constructor( props ) {
    super( props );
    this.months = [];
    for ( let i = 1; i <= 12; i++ ) {
      this.months.push( i );
    }
    this.years = [];
    const[ toY, toM, toD ] = this.props.to.split( '-' ).map( n => parseInt( n, 10 ) );
    const[ fromY, fromM, fromD ] = this.props.from.split( '-' ).map( n => parseInt( n, 10 ) );
    for ( let i = 0, l = toY - fromY; i <= l; i++ ) {
      this.years.push( toY - i );
    }
  }

  getCurrent() {
    return this.props.date.split( '-' ).map( n => parseInt( n, 10 ) );
  }

  getDays() {
    let [ curY, curM, curD ] = this.getCurrent();
    const days = [];
    for ( let i = 1, l = this.dateMax( curY, curM, 31 ); i <= l; i++ ) {
      days.push( i );
    }
    return days;
  }

  dateMax( year, month, day ) {
    if ( 2 === month ) {
      if ( year % 4 === 0 && year % 500 !== 0) {
        return Math.min( 29, day )
      } else {
        return Math.min( 28, day )
      }
    } else if ( [ 4, 6, 9, 11 ].indexOf( month ) < 0 ) {
      return Math.min( 31, day );
    } else {
      return Math.min( 30, day );
    }
  }

  setDate( obj ) {
    let [ curY, curM, curD ] = this.getCurrent();
    const vars = Object.assign( {
      curY,
      curM,
      curD,
    }, obj );
    vars.curD = this.dateMax( vars.curY, vars.curM, vars.curD );
    let date = sprintf( '%04d-%02d-%02d', vars.curY, vars.curM, vars.curD );
    if ( date > this.props.to ) {
      date = this.props.to;
    } else if ( date < this.props.from ) {
      date = this.props.from;
    }
    this.props.dateChange( date );
  }

  render () {
    let [ curY, curM, curD ] = this.getCurrent();
    return (
      <Fragment>
        <div className="col d-flex search-col">
          <select className="custom-select filter-input" value={curY}
                  id="inlineFormCustomSelect" onChange={ e => { this.setDate( { curY: parseInt( e.target.value, 10 ) } ) } }>
            { this.years.map( ( year ) => {
              return (
                <option value={ year }>{year}</option>
              )
            } ) }
          </select>
          <span className="mx-1 search-box-field-label">年</span>
        </div>
        <div className="col d-flex search-col">
          <select className="custom-select filter-input" value={ curM }
                  id="inlineFormCustomSelect" onChange={ e => { this.setDate( { curM: parseInt( e.target.value, 10 ) } )  } }>
            { this.months.map( ( month ) => {
              return (
                <option value={ month }>{ sprintf( '%02d', month ) }</option>
              )
            } ) }
          </select>
          <span className="mx-1 search-box-field-label">月</span>
        </div>
        <div className="col d-flex search-col">
          <select className="custom-select filter-input" value={curD}
                  id="inlineFormCustomSelect" onChange={ e => { this.setDate( { curD: parseInt( e.target.value, 10 ) } ) } }>
            { this.getDays().map( ( day ) => {
              return <option value={day}>{ sprintf( '%02d', day ) }</option>
            } ) }
          </select>
          <span className="mx-1 search-box-field-label">日</span>
        </div>
      </Fragment>
    );
  }

}

export class DateRange extends Component {

  setRange( newDate ) {
    let range = Object.assign( {
      from: this.props.from,
      to: this.props.to,
    }, newDate );
    if ( range.from > range.to ) {
      range.from = range.to;
    }
    this.props.rangeHandler( range );
  }


  render() {
    const toLimit = PaidMediaSearchVars.today;
    let fromLimit;
    switch ( this.props.simple ) {
      case 'oldest':
        fromLimit = PaidMediaSearchVars.oldest;
        break;
      case true:
        fromLimit = PaidMediaSearchVars.twoYearsAgo;
        break;
      default:
        fromLimit = PaidMediaSearchVars.webOldest;
        break;
    }

    return (
      <div className="form-row">
        <label className="date-range-label">from</label>
        <DatePicker date={this.props.from} from={fromLimit} to={toLimit} dateChange={date => {
          this.setRange({from: date})
        }}/>
        <div className="col-0 d-flex search-separator">
          <span className="mx-1 search-box-field-label">−</span>
        </div>
        <label className="date-range-label">to</label>
        <DatePicker date={this.props.to} from={fromLimit} to={toLimit} dateChange={date => {
          this.setRange({to: date})
        }}/>
      </div>
    );
  }
}
